import { ModalStyled } from 'components/UI/styled/modal-styled';
import React from 'react';
import Container from 'react-bootstrap/esm/Container';
import { Indicacao } from 'models/indicacoes';
import Button from "react-bootstrap/Button";
import indicacoesService from 'services/indicacao-especial-service/indicacao-especial-service';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onDelete: (id) => void;
  indicacao?: Indicacao;
  isExpress: boolean;
}

const DeletarIndicacaoModal = (props: Props) => {

  const onClickDelete = (id) => {
    if(id){
      if(props.isExpress){
        indicacoesService.deleteIndicacaoEspecialExpress(id)
          .then(resp => {
            props.onDelete(id);
          })
          .catch(err => {
            console.log(err);
          });
      }else{
        indicacoesService.deleteIndicacaoEspecial(id)
          .then(resp => {
            props.onDelete(id);
          })
          .catch(err => {
            console.log(err);
          });
      }

    }
  }

  return (
    <ModalStyled
      show={props.isOpen}
      onHide={props.onClose}
      className="modal-md"
    >
      <ModalStyled.Header closeButton>
        <ModalStyled.Title>
          Deletar indicação especial
        </ModalStyled.Title>
      </ModalStyled.Header>

      <ModalStyled.Body>
        <Container fluid className="pl-0 pr-0">
          <p>Tem certeza que deseja deletar a indicação especial com CPF: {props.indicacao?.cpf}?</p>
          <div className="talign-right">
            <Button className="mr-1" onClick={()=>{onClickDelete(props.indicacao?.id)}} variant="primary" type="submit">Sim</Button>
            <Button onClick={()=>{props.onClose()}} variant="primary" type="submit">Não</Button>
          </div>
        </Container>
      </ModalStyled.Body>
    </ModalStyled>
  );
}

export default DeletarIndicacaoModal;